// @flow
import React from 'react';
import { useSelector } from 'react-redux';
import Button from 'material-ui/Button';
import * as Authorization from '../../lib/authorization';
import { FEATURES } from '../../v5/features/components/constants';
import SegmentService, {
    EVENTS as SEGMENT_EVENTS
} from '../../lib/segment/SegmentService';

export default function AssistantCoachButton() {
    const { loggedInUser, headCoach } = useSelector((state: any) => state.app);
    const features = useSelector((state: any) => state.features);

    if (!loggedInUser || !headCoach || !features[FEATURES.COACH_PRICING]) {
        return null;
    }

    const isTrialOrBasicUser = loggedInUser.isTrial || loggedInUser.isBasic;
    if (isTrialOrBasicUser) return null;

    const redirectToAssistantCoachSettings = () => {
        SegmentService.track(SEGMENT_EVENTS.ClickCTA.key, {
            sources: 'Web app',
            ctaLocation: 'Main Nav',
            ctaText: 'Manage Assistant Coaches'
        });
        return (window.location =
            Authorization.navigateToAssistantCoaches.path);
    };

    return (
        <Button
            onClick={redirectToAssistantCoachSettings}
            className="contained-button"
        >
            Manage Assistant coaches
        </Button>
    );
}
